/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js";
import firebase from "firebase/app";
import "firebase/auth";
import router from "@/router";
import * as constants from "@/constants";
import CryptoJS from "crypto-js";
import {v4 as uuidv4} from "uuid";

export default {
	login({commit, state, dispatch}, payload) {
		firebase
			.auth()
			.signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
			.then(
				(result) => {
					// Set FLAG username update required for updating username
					let isUsernameUpdateRequired = false;
					// if username is provided and updateUsername FLAG is true
					// set local username update FLAG to true
					// try to update username
					if (payload.updateUsername && payload.userDetails.displayName) {
						isUsernameUpdateRequired = true;
						dispatch("updateUsername", {
							user: result.user,
							username: payload.userDetails.displayName,
							notify: payload.notify,
							isReloadRequired: true,
						});
					}
					// Close animation if passed as payload
					// if (payload.closeAnimation) payload.closeAnimation()
					// if username update is not required
					// just reload the page to get fresh data
					// set new user data in localstorage
					if (!isUsernameUpdateRequired) {
						const userInfo = {uid: result.user.uid, email: result.user.email};
						commit("UPDATE_USER_INFO", userInfo, {root: true});
						//commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true});
						// xlifems login aqui con uuid de firebase
						payload.userDetails.uid = result.user.uid;
						payload.userDetails.code = payload.code;

						dispatch("loginJWT", payload);
					}
				},
				(err) => {
					// Close animation if passed as payload
					if (payload.closeAnimation) payload.closeAnimation();

					dispatch("loginFailTrackingService", payload.userDetails.email);
					let errorMessage = "";
					switch (err.code) {
						case "auth/wrong-password":
							errorMessage = payload.logingMessagesValidations.InvalidPassword;
							break;
						case "auth/user-not-found":
							errorMessage = payload.logingMessagesValidations.UserNotFound;
							break;
						case "auth/too-many-requests":
							errorMessage = payload.logingMessagesValidations.TooManyRequests;
							break;
						default:
							errorMessage = `${err.code}: ${err.message}`;
							break;
					}

					payload.notify({
						time: 6000,
						title: "Error",
						text: errorMessage,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
					});
				}
			);
	},
	async loginFailTrackingService({commit, state}, eMail) {
		const IP = await fetch("https://api.ipify.org/?format=json", {method: "get"});
		await IP.json();
	},
	// Google Login
	loginWithGoogle({commit, state, dispatch}, payload) {
		const provider = new firebase.auth.GoogleAuthProvider();

		firebase
			.auth()
			.signInWithPopup(provider)
			.then(async (result) => {
				let isUsernameUpdateRequired = false;

				if (payload.updateUsername && payload.userDetails.displayName) {
					isUsernameUpdateRequired = true;

					dispatch("updateUsername", {
						user: result.user,
						username: payload.userDetails.displayName,
						notify: payload.notify,
						isReloadRequired: true,
					});
				}

				if (!isUsernameUpdateRequired) {
					const userInfo = {uid: result.user.uid, email: result.user.email};
					commit("UPDATE_USER_INFO", userInfo, {root: true});
					payload.userDetails.uid = result.user.uid;
					payload.userDetails.email = result.user.email;
					payload.openAnimation();
					await dispatch("loginJWT", payload);
					payload.closeAnimation();
				}
			})
			.catch((err) => {
				let errorMessage = "";
				switch (err.code) {
					case "auth/wrong-password":
						errorMessage = payload.logingMessagesValidations.InvalidPassword;
						break;
					case "auth/user-not-found":
						errorMessage = payload.logingMessagesValidations.UserNotFound;
						break;
					case "auth/too-many-requests":
						errorMessage = payload.logingMessagesValidations.TooManyRequests;
						break;
					default:
						errorMessage = `${err.code}: ${err.message}`;
						break;
				}

				payload.notify({
					time: 6000,
					title: "Error",
					text: errorMessage,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			});
	},
	// Esta funcion es utilizada para la creacion de recursos
	registerUser({dispatch}, payload) {
		// create user using firebase
		return new firebase.auth().createUserWithEmailAndPassword(
			payload.userDetails.email,
			payload.userDetails.password
		);
	},

	deleteUserFromFirebase({dispatch}) {
		const user = firebase.auth().currentUser;
		return user.delete();
	},
	updateUsername({commit}, payload) {
		payload.user
			.updateProfile({
				displayName: payload.displayName,
			})
			.then(() => {
				// If username update is success
				// update in localstorage
				const newUserData = Object.assign({}, payload.user.providerData[0]);
				newUserData.displayName = payload.displayName;
				commit("UPDATE_USER_INFO", newUserData, {root: true});

				// If reload is required to get fresh data after update
				// Reload current page
				if (payload.isReloadRequired) {
					router.push(router.currentRoute.query.to || "/");
				}
			})
			.catch((err) => {
				payload.notify({
					time: 8800,
					title: "Error",
					text: err.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			});
	},

	// JWT
	loginJWT({commit, dispatch}, payload) {
		return new Promise((resolve, reject) => {
			jwt.login(payload.userDetails.email, payload.userDetails.uid, payload.userDetails.code)
				.then((response) => {
					// If there's user data in response
					if (response.data) {
						// Set accessToken
						localStorage.setItem("accessToken", response.data.access_token);
						// Set UID
						localStorage.setItem("open-route-uid", response.data.uid);
						// Update user details

						if (payload.checkbox_remember_me) {
							localStorage.setItem("userDetail", JSON.stringify(payload.userDetails));
						} else {
							localStorage.removeItem("userDetail");
						}

						commit("UPDATE_USER_INFO", response.data, {root: true});
						// Set bearer token in axios
						commit("SET_BEARER", response.data.access_token);
						jwt.saveDataLogin(response.data).then((res) => {});
						// Navigate User to homepage
						router.push(router.currentRoute.query.to || "/dashboard/home");

						// Close animation if passed as payload
						if (payload.closeAnimation) payload.closeAnimation();

						resolve(response);
					} else {
						payload.closeAnimation();
						reject({message: "Wrong Email or Password"});
					}
				})
				.catch((error) => {
					payload.closeAnimation();
					dispatch("loginFailTrackingService", payload.userDetails.email);

					let text = "";
					switch (error.data) {
						case "company out of operating dates":
							text = payload.logingMessagesValidations.CompanyReachedWorkingDate;
							break;
						case "Not valid code":
							text = payload.logingMessagesValidations.InvalidCode;
							break;
						default:
							text = `${error.status}: ${error.data}`;
							break;
					}

					payload.notify({
						time: 6000,
						title: "Error",
						text: text,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
					});
					reject({message: "Wrong Email or Password"});
				});
		});
	},
	registerUserJWT({commit}, payload) {
		const {displayName, email, password, confirmPassword} = payload.userDetails;

		return new Promise((resolve, reject) => {
			// Check confirm password
			if (password !== confirmPassword) {
				reject({message: "Password doesn't match. Please try again."});
			}

			jwt.registerUser(displayName, email, password)
				.then((response) => {
					// Redirect User
					router.push(router.currentRoute.query.to || "/");

					// Update data in localStorage
					localStorage.setItem("accessToken", response.data.accessToken);
					commit("UPDATE_USER_INFO", response.data.userData, {root: true});

					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchAccessToken() {
		return new Promise((resolve) => {
			jwt.refreshToken().then((response) => {
				resolve(response);
			});
		});
	},
	responseRegister() {
		return new Promise((resolve, reject) => {
			Api.get("/role")
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	loadFirestore() {
		let db = firebase.firestore();
		db.collection("cerberus_PositionRecord")
			.get()
			.then((querySnapshot) => {
				querySnapshot.forEach((doc) => {});
			});
	},
	/**
	 * @description Metodo para obtener informacion de la empresa entes de autenticarnos en la plataforma
	 * requiere que se envie un token codificado que el backend decodificara para mas seguridad
	 * el token es generado con la fecha un ramdon codigo y la key recuperada desde firebase
	 * @param {*} param0
	 * @param {*} param1
	 * @returns
	 */
	loginBefore({dispatch}, {email}) {
		return new Promise((resolve, reject) => {
			(async () => {
				// fecha actual
				const now = new Date();
				const year = now.getUTCFullYear();
				const month = now.getUTCMonth() + 1;
				const day = now.getUTCDate();
				const formatNow = `${year}${month > 9 ? month : "0" + month}${day > 9 ? day : "0" + day}`;

				// Generamos un codigo
				const code = uuidv4();

				// Creamos el payload para la petecion
				const payload = {
					keys: ["visual_config", "firebase_config"],
					client_secret: process.env.VUE_APP_CLIENT_SECRET,
					email,
					code,
				};

				try {
					// Recuperamos la web random key desde firebase
					const randomKey = await dispatch("recoveryRandomKey");

					// Generamos SHA-512 hash con los valores
					const hash512 = CryptoJS.SHA512(randomKey + formatNow + code).toString();

					// Ejecutamos la peticicon
					const response = await fetch(constants.API_BASE_URL + "/before/login", {
						method: "POST",
						body: JSON.stringify(payload),
						headers: {
							"Content-Type": "application/json",
							Authorization: `Bearer ${hash512.substring(0, 30)}`,
						},
					});
					const jsonResponse = await response.json();
					if (jsonResponse.status === 400) {
						reject(jsonResponse);
					} else {
						resolve(jsonResponse);
					}
				} catch (error) {
					await fetch(constants.API_BASE_URL + "/before/login", {
						method: "POST",
						body: JSON.stringify(payload),
						headers: {
							"Content-Type": "application/json",
						},
					});
					reject(error);
				}
			})();
		});
	},
	/**
	 * @description  Recuperar valor random key para la web desde firebase para crear token
	 * @returns String
	 */
	recoveryRandomKey() {
		return new Promise((resolve, reject) => {
			// Crear referencia a firebase para obtener la random key
			const randomKeyRef = firebase.database().ref("random_key/WEB");
			randomKeyRef
				.once("value")
				.then(function (snapshot) {
					const randomKey = snapshot.val();
					if (randomKey) {
						resolve(randomKey);
					} else {
						reject(new Error("Error"));
					}
				})
				.catch((err) => {
					console.err(err);
				});
		});
	},
	recoveryTwoFactorCode({dispatch}, {email}) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const response = await fetch(constants.API_BASE_URL + "/codetfa", {
						method: "POST",
						body: JSON.stringify({email}),
						headers: {
							"Content-Type": "application/json",
						},
					});
					const jsonResponse = await response.json();
					if (jsonResponse.status === 400) {
						reject(jsonResponse);
					} else {
						resolve(jsonResponse);
					}
				} catch (error) {
					reject(error);
				}
			})();
		});
	},
};
